<template>
  <div>
  <div class="Stoff" v-if="isStoffAnzeige">

    <img :src="technologie.imageURL" class="ultra-dry" :alt="technologie.title" :title="technologie.title"/>
      <div class="ultra-dry-stoff-img">
        <picture>
          <source :srcset="technologie.imageGraphMobileURLSrcSet" media="(max-width: 500px)">
          <img :srcset="technologie.imageGraphURLSrcSet" :src="technologie.imageGraphURL" class="ultra-dry-stoff-img" :alt="technologie.title" :title="technologie.title"/>
        </picture>
      </div>
      <p>
        {{technologie.description}}
      </p>

      <div class="stoffeigenschaften">

        <div class="row" :key="stoffeigenschaft.stoffeigenschaft" v-for="stoffeigenschaft in technologie.stoffeigenschaften">
          <div class="icon-col">
            <img :src="stoffeigenschaft.imageURL" :alt="stoffeigenschaft.eigenschaft" :title="stoffeigenschaft.eigenschaft"/>
          </div>
          <div class="text-col">
            {{stoffeigenschaft.text}}
          </div>
        </div>
      </div>
    </div>

    <div class="ofit-wrapper" v-if="!isStoffAnzeige">

      <div class="ofit col-50">
        <img :src="technologie.imageURL" :alt="technologie.title" :title="technologie.title"/>
      </div>
      <div class="col-50">
        <p>
          <strong>{{technologie.title}}</strong><br/>
          {{technologie.description}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {computed} from "vue";

export default {
  name: "ProductViewDetailsTechnologien",
  props: {
    technologie: Object
  },
  setup(props) {
    return{
      isStoffAnzeige: computed(()=>props.technologie.anzeigeArt === "Stoff")
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~/assets/scss/settings/_config.scss" as *;
.Stoff {
  position: relative;
  border-top: 1px solid $color-grey;
  padding: 20px;

  .ultra-dry {
    position: absolute;
    right: -10px;
    top: -20px;

    @media (max-width: 540px) {
      max-width: 100px;
    }
  }
  .ultra-dry-stoff-img {
    width: 400px;
    max-width: 100%;
    margin: 20px auto;

    @media (max-width: 540px) {
      width: auto;
    }
  }

  .stoffeigenschaften {
    display: none;
  }
}

.ofit-wrapper {
  position: relative;
  padding: 20px;
  border-top: 1px solid $color-grey;
  display: flex;
  justify-content: space-between;

  .col-50 {
    width: 50%;

    &.ofit {
      text-align: center;
      padding-top: 30px;
    }
  }

  @media (max-width: 540px) {
    flex-direction: column;

    .col-50 {
      width: 100%;

      &.ofit {
        padding-bottom: 30px;
      }
    }
  }
}
</style>


